module.exports = __webpack_public_path__ + "static/media/family_20.4daf892e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_20.jpg
// module id = 5851
// module chunks = 0